import { render } from "./OpenDoor.vue?vue&type=template&id=4dfb7521&scoped=true"
import script from "./OpenDoor.vue?vue&type=script&lang=js"
export * from "./OpenDoor.vue?vue&type=script&lang=js"

import "./OpenDoor.vue?vue&type=style&index=0&id=4dfb7521&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dfb7521"]])

export default __exports__